<template>
  <div>
    <div v-if="session">
      <h3>{{ $t("events.participation.header") }}</h3>
      <div>
        <vca-card v-if="userParticipation && applicationStatus != 'withdrawn'">
          <div v-if="!eventClosed" class="vca-center">
            <vca-cancel-button
              @click="withdraw()"
              :title="
                $t('context_button.cancelling', {
                  0: $t('events.participation.header'),
                })
              "
              :placeholder="
                $t('context_button.cancelling', {
                  0: $t('events.participation.header'),
                })
              "
            />
          </div>
          <div v-else>
            <vca-card class="text-center">
              <div class="bold highlight">
                {{ $t("events.application.event_over_participated") }}
              </div>
            </vca-card>
          </div>
        </vca-card>
        <div v-else-if="!eventClosed">
          <div>
            <h3>{{ $t("events.application.additional.label") }}</h3>
            <vca-textarea
              v-model="value.comment"
              :placeholder="$t('events.application.additional.placeholder')"
            />
          </div>
          <div v-if="userParticipation && applicationStatus == 'withdrawn'">
            <div>
              {{ $t("events.application.participate_again") }}
            </div>
            <button
              @click="reapply()"
              :title="$t('button.participate')"
              class="vca-button"
            >
              {{ $t("button.participate") }}
            </button>
          </div>
          <div v-else>
            <button
              @click="apply()"
              :title="$t('button.participate')"
              class="vca-button"
            >
              {{ $t("button.participate") }}
            </button>
          </div>
        </div>
        <div v-else>
          <vca-card class="text-center">
            <div class="bold highlight">
              {{ $t("events.application.event_over") }}
            </div>
          </vca-card>
        </div>
      </div>
    </div>
    <div v-else>
      <button
        @click="register()"
        :title="$t('events.button.register_apply')"
        class="vca-button"
      >
        {{ $t("events.button.register_apply") }}
      </button>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  name: "CrewEventApplicationParticipation",
  props: {
    event: {
      type: Object,
      default: null,
    },
  },
  computed: {
    ...mapGetters({
      session: "session",
      user: "user/current",
      poolEventPermissions: "user/roles/poolEventPermissions",
      hasPoolPermission: "user/roles/hasPoolPermission",
      hasSystemPermission: "user/roles/hasSystemPermission",
      user_participations: "events/participations/list",
    }),
    create: {
      set(value) {
        this.$store.commit("events/participations/create", value);
      },
      get() {
        return this.$store.state.events.participations.create;
      },
    },
    value: {
      set(value) {
        this.userApplication
          ? (this.userApplication = value)
          : (this.create = value);
      },
      get() {
        return this.userApplication ? this.userApplication : this.create;
      },
    },
    applicationStatus() {
      return this.userApplication.status;
    },
    userApplication() {
      return this.user_participations
        ? this.user_participations.find((el) => el.event_id == this.event.id)
        : null;
    },
    userParticipation() {
      return (
        this.session && this.user_participations && this.userApplication != null
      );
    },
    eventClosed() {
      return (
        new Date() > new Date(this.event.end_at * 1000) ||
        this.event.event_state.state === "closed" ||
        this.event.event_state.state === "finished"
      );
    },
  },
  methods: {
    reloadParticipations() {
      let data = { user_id: this.user.id };
      this.$store
        .dispatch({
          type: "events/participations/listUser",
          data: data,
        })
        .then((response) => {
          this.$store.commit(
            "events/participations/list",
            !response || response.length == 0 ? [] : response
          );
        });
      if (
        this.hasSystemPermission() ||
        this.hasPoolPermission(this.poolEventPermissions)
      ) {
        this.$store.dispatch({ type: "events/list" });
      }
    },
    apply() {
      if (!confirm(this.$t("events.application.messages.participate"))) {
        return false;
      }
      this.$store.dispatch({ type: "events/participations/apply" }).then(() => {
        this.reloadParticipations();
      });
      this.$emit("close");
    },
    register() {
      this.$router.push({ path: "/register" });
    },
    withdraw() {
      if (!confirm(this.$t("events.application.messages.withdraw"))) {
        return false;
      }
      this.$store.commit("events/participations/current", this.userApplication);
      this.$store
        .dispatch({ type: "events/participations/withdraw" })
        .then(() => {
          this.reloadParticipations();
        });
      this.$emit("close");
    },
    reapply() {
      if (!confirm(this.$t("events.application.messages.reparticipate"))) {
        return false;
      }
      this.$store.commit("events/participations/current", this.userApplication);
      this.$store
        .dispatch({ type: "events/participations/accept" })
        .then(() => {
          this.reloadParticipations();
        });
      this.$emit("close");
    },
  },
};
</script>
